import { Type } from 'class-transformer';
import { IsInt, IsOptional, IsString, Max, MaxLength, Min } from 'class-validator';
import {
  DEADLINE_ASSIGNEE_ID_MAX_LENGTH,
  DEADLINE_TITLE_MAX_LENGTH,
  MAX_RENEWAL_VALIDITY_MONTHS,
} from './deadline.constants';
import { DEADLINE_UPLOAD_TOKEN_MAX_LENGTH } from './deadline-ai.constants';
import { DeadlineWarningDaysDto } from './deadline-warning-days.dto';
import { IsIsoDay } from './is-iso-day.decorator';

export class CreateDeadlineDto extends DeadlineWarningDaysDto {
  @IsOptional()
  @IsString()
  documentTypeId?: string;

  /** Titolo libero: obbligatorio se manca `documentTypeId` (verificato dal service). */
  @IsOptional()
  @IsString()
  @MaxLength(DEADLINE_TITLE_MAX_LENGTH)
  title?: string;

  /** Assente = nessuna scadenza (bucket NO_DEADLINE). */
  @IsOptional()
  @IsIsoDay()
  dueAt?: string;

  /** Collega un documento già in archivio senza altra scadenza. */
  @IsOptional()
  @IsString()
  signedDocumentId?: string;

  /** Documento già caricato in anteprima (`POST deadlines/ai-preview`): si archivia insieme alla scadenza. */
  @IsOptional()
  @IsString()
  @MaxLength(DEADLINE_UPLOAD_TOKEN_MAX_LENGTH)
  uploadToken?: string;

  /** Solo per i tipi `isPersonal`: membro attivo del tenant (verificato dal service, 422). */
  @IsOptional()
  @IsString()
  @MaxLength(DEADLINE_ASSIGNEE_ID_MAX_LENGTH)
  assigneeUserId?: string;

  /** Spec §11.1: con `dueAt` = ricorrente; senza `dueAt` = ricorrente senza data (template studio). */
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  @Max(MAX_RENEWAL_VALIDITY_MONTHS)
  validityMonths?: number;
}
